export enum ConsultantQualityReferenceType {
  CurrentBoss = "CurrentBoss",
  LatestBoss = "LatestBoss",
  FormerBoss = "FormerBoss", // old boss
  CurrentColleague = "CurrentColleague",
  FormerColleague = "FormerColleague" // old Colleague
  // UUCountsAsManager = "UUCountsAsManager", // logic wise it should be treated as “Senaste chef”
  // UU = "UU" // does not count as anything
}
